<template>
  <v-btn
    color="mainBlue"
    class="white--text"
    :disabled="disabled"
    @click="handleExport"
  >
    Export CSV
  </v-btn>
</template>

<script>
import { exportCSV } from "@/core/utils/export.utils";
import moment from "jalali-moment";

export default {
  name: "HistoryExport",

  props: {
    title: { type: String, required: true },
    filterData: { type: Object, required: true },
    exportData: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },

  computed: {
    from() {
      if (!this.filterData.created_at_from) return undefined;
      return moment(this.filterData.created_at_from).format("jYYYY-jMM-jDD");
    },
    to() {
      if (!this.filterData.created_at_to) return undefined;
      return moment(this.filterData.created_at_to).format("jYYYY-jMM-jDD");
    },
    limit() {
      return this.filterData.limit;
    },
  },

  methods: {
    handleExport() {
      const title = `${this.title} history export${
        this.from ? ` from ${this.from}` : ""
      }${this.to ? ` to ${this.to}` : ""}${
        this.limit ? ` with limit ${this.limit}` : ""
      }`;
      const { headers, data } = this.exportData;

      exportCSV({ title, headers, data });
    },
  },
};
</script>
